import React from 'react';
import { Truck, LogOut } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

export default function Header() {
  const { user, logout } = useAuth();

  return (
    <header className="bg-white border-b border-locate2-border sticky top-0 z-10">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-locate2-primary rounded-lg flex items-center justify-center">
            <Truck size={18} className="text-white" />
          </div>
          <span className="text-xl font-bold text-locate2-dark-blue">Locate2u</span>
          <span className="text-locate2-light-gray text-sm ml-2 hidden sm:inline">
            Import Processing Portal
          </span>
        </div>
        <div className="flex items-center gap-4">
          <div className="text-right hidden sm:block">
            <p className="text-locate2-medium-gray text-sm font-medium">{user?.name}</p>
            <p className="text-locate2-light-gray text-xs">{user?.email}</p>
          </div>
          <button
            onClick={logout}
            className="flex items-center gap-2 px-3 py-2 text-locate2-light-gray hover:text-status-error hover:bg-locate2-bg-light rounded-lg transition-colors"
          >
            <LogOut size={18} />
            <span className="hidden sm:inline">Sign out</span>
          </button>
        </div>
      </div>
    </header>
  );
}
